module.exports = require('./helpers/bundle-url').getBundleURL('guoIO') + "logo-dark.eefe0b7f.svg";